import { render, staticRenderFns } from "./UsedEntitlement.vue?vue&type=template&id=2b28918e&scoped=true&"
import script from "./UsedEntitlement.vue?vue&type=script&lang=js&"
export * from "./UsedEntitlement.vue?vue&type=script&lang=js&"
import style0 from "./UsedEntitlement.vue?vue&type=style&index=0&id=2b28918e&prod&lang=scss&scoped=true&"
import style1 from "./UsedEntitlement.vue?vue&type=style&index=1&id=2b28918e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b28918e",
  null
  
)

export default component.exports